import { Auth } from "aws-amplify";
import { expireSession } from "./sessionExpiry";
import { getHostedUiToken } from "./hostedUiToken";

let onToken = null;

export function setTokenListener(listener) {
  onToken = listener;
}

export async function apiFetch(url, options = {}) {
  let token;
  try {
    token = (await Auth.currentSession()).getIdToken().getJwtToken();
  } catch {
    token = getHostedUiToken();
    if (!token) {
      expireSession();
      throw new Error("Session expired");
    }
  }

  if (onToken) {
    onToken(token);
  }

  const headers = {
    Authorization: `Bearer ${token}`,
    ...options.headers,
  };

  const response = await fetch(url, { ...options, headers });
  if (response.status === 401) {
    expireSession();
    throw new Error("Session expired");
  }
  return response;
}
